import React, { ReactElement } from 'react';
import {
  sessionApi,
  usePostSessionVmActionMutation,
} from '../../../../../../../../redux/views/session-view/session/api/api';
import { getMorIdFromSessionDetails } from '../../../../../utils';
import { ControlProps } from './container';
import { Control } from '.';

type ConnectedDCloudControlProps = ControlProps & FetchSessionArgs;

export function ConnectedDCloudControl({
  nodeUid,
  sessionUid,
  versionUid,
}: ConnectedDCloudControlProps): ReactElement {
  const { mor } = sessionApi.endpoints.getSession.useQueryState(
    { sessionUid, versionUid },
    {
      selectFromResult: ({ data }) => ({
        mor: getMorIdFromSessionDetails(
          (
            data?.diagram.nodes.filter(
              (node) => node.uid === nodeUid,
            )[0] as SessionVmNode
          ).sessionDetails,
        ),
      }),
    },
  );
  const [postSessionVmAction] = usePostSessionVmActionMutation();

  const postVmAction = (action: SessionVmActions) => {
    postSessionVmAction({
      action,
      mor,
      sessionId: sessionUid,
      topologyVersion: { uid: versionUid },
    });
  };

  return <Control postVmAction={postVmAction} />;
}
